// event
const Listevent = () => import('@/views/content-management/event')
const Formevent = () => import('@/views/content-management/event/form')

export default {
    path: 'event',
    redirect: '/event',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'event',
            component: Listevent,
            meta: {
                link: 'event',
                breadcrumb: [
                    { title: 'Content Management', active: true },
                    { title: 'Event', active: true },
                ],
                pageTitle: 'Event'
            }
        },
        {
            path: 'add',
            name: 'addevent',
            component: Formevent,
            meta: {
                link: 'event',
                breadcrumb: [
                    { title: 'Content Management', active: true },
                    { title: 'Event', url: '/event' },
                    { title: 'Create', active: true },
                ],
                pageTitle: 'Create Event'
            }
        },
        {
            path: 'edit/:id',
            name: 'editevent',
            component: Formevent,
            meta: {
                link: 'event',
                breadcrumb: [
                    { title: 'Content Management', active: true },
                    { title: 'Event', url: '/event' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Event'
            }
        }
    ]
}